<template>
  <div class="login-modify-set-password-dialog">
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal=false
      :modal=false
      width="352"
      >
      <div class="login-modify-set-password-dialog_title">{{modifySetPassword}}</div>
      <div class="change-password-box">
        <div class="change-password-container-input">
          <div class="change-username-input">
            <el-input
              v-model="userName"
              disabled
            >
            </el-input>  
            <div class="username-input-prompt">账号为手机号不可修改</div>
          </div>
          <div class="change-password-input">
            <el-input
              @focus="passwordInputFocus"
              v-model="password"
              :type="passwordType"
              placeholder="密码（支持数字、大小写字母和下划线组合,8-16个字符）"
            >
            </el-input>  
            <img @click="passwordType='text'" v-if="password && passwordType === 'password'" class="password-icon" src="../../assets/img/show-password.svg" alt="">
            <img @click="passwordType='password'" v-if="password && passwordType !== 'password'" class="password-icon" src="../../assets/img/hidden-password.svg" alt="">
            <div v-if="isPasswordError" class="password-error">{{passwordError}}</div>
          </div>
        </div>
        <div class="change-password-container-button">
          <el-button v-if="password" :loading="confirmLoading" @click="onConfirmClick" class="confirm-btn">确认</el-button>
          <el-button v-else class="no-confirm-btn">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import authQuery from '@/rest/authQuery';
import localStorageHelper from '@/helpers/localStorageHelper';
import { 
  HAS_PASSWORD
} from '@/helpers/constants';

export default {
  data() {
    return {
      visible: false,
      modifySetPassword: '设置密码',
      userName: '',
      password: '',
      passwordType: 'password',
      passwordError: '',
      isPasswordError: false,
      confirmLoading: false
    };
  },
  methods: {
    onConfirmClick() {
      if (!this.password) {
        this.passwordError = '密码不能为空';
        this.isPasswordError = true;
      } else if (!/^([a-zA-Z0-9]|[_]){8,16}$/.test(this.password)) {
        this.passwordError = '密码（支持数字、大小写字母和下划线组合,8-16个字符）';
        this.isPasswordError = true;
      } else {
        this.confirmLoading = true;
        authQuery.setPass(this.userName, this.password).then(() => {
          authQuery.hasPass(this.userName).then(res => {
            this.confirmLoading = false;
            localStorageHelper.setItem(HAS_PASSWORD, res.has_password);
            this.visible = false;
            this.password = '';
            this.$message({
              message: `${this.modifySetPassword}成功`,
              duration: 2000,
              type: 'success'
            });
            this.$emit('changePasswordState');
          });
        });
      }
    },
    passwordInputFocus() {
      this.isPasswordError = false;
      this.passwordError = '';
    },
    openModifySetPasswordDialog(res) {
      this.modifySetPassword = res.passwordName;
      this.userName = res.userName; 
      this.password = '';
      this.visible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.login-modify-set-password-dialog {
  &_title {
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
    font-size: 14px;
    color:#171f46;
    font-weight:500;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px #f7f7fa;
  }
  .change-password-box {
    padding-top: 10px;
    height: 260px;
    background: #ffffff;
    .change-password-container-input {
      height: 185px;
      padding: 14px 24px 24px;
      box-shadow: inset 0px -1px 0px 0px #f7f7fa;
      .change-username-input {
        position: relative;
        margin-bottom: 16px;
        .username-input-prompt {
          position: absolute;
          top: 12px;
          right: 12px;
          color: #B9BCC8;
          font-size: 12px;
        }
      } 
      .change-password-input {
        position: relative;
        .password-icon {
          position: absolute;
          width: 17px;
          top: 12px;
          right: 12px;
          cursor: pointer;
        }
        .password-error {
          width: 100%;
          height: 16px;
          line-height: 16px;
          padding-left: 16px;
          color: #ff5b65;
          font-size: 12px;
          background-color: rgba(255, 91, 101, 0.1);
        }
      }
    }
    .change-password-container-button {
      line-height: 64px;
      text-align: center;
      .confirm-btn {
        height: 32px;
        width: 74px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #ffffff;
        background-color: #45a8cc;
        font-weight: 400;
        &:hover {
          color: #ffffff;
          background-color: #3e97b8;
        }
        &:focus {
          color: #ffffff;
          background-color: #3e97b8;
        }
        &:active {
          color: #ffffff;
          background-color: #3e97b8;
        }
      }
      .no-confirm-btn {
        height: 32px;
        width: 74px;
        padding: 0;
        border-radius: 2px;
        border: none;
        font-size: 14px;
        color: #ffffff;
        background-color: rgba(69, 168, 204, 0.4);
        font-weight: 400;
        cursor: auto;
        &:hover {
          color: #ffffff;
          background-color: rgba(69, 168, 204, 0.4);
        }
        &:focus {
          color: #ffffff;
          background-color: rgba(69, 168, 204, 0.4);
        }
        &:active {
          color: #ffffff;
          background-color: rgba(69, 168, 204, 0.4);
        }
      }
    }
  }
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 400px !important;
      position: relative;
      margin-top: 25vh !important;
      border-radius: 8px;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 14px;
          .el-dialog__close {
            color: #514d4f;
          }
        }
      }
      .el-dialog__body {
        padding: 0;
        .el-textarea {
          .el-textarea__inner {
            margin-bottom: 0;
            background-color: #f7f8fc;
            border-radius: 2px;
            border: none;
            color: #747990;
          }
        }
      }
    }
  }
}
/deep/ .el-input {
  .el-input__inner {
    height: 40px;
    line-height: 40px;
    padding: 0 33px 0 15px;
    border: 1px solid #e5e6ee !important;
    color: #171f46;
    background: #ffffff;
    &::-webkit-input-placeholder {
      color: #b9bcc8;
      font-size: 12px;
    }
    &:hover {
      border-color: #d1d2da !important;
    }
    &:focus {
      border-color: #747990 !important;
    }
  }
}
</style>
